import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import CardItem from "./CardItem";
import AddAssetsModal from "./AddAssetsModal";
import AssetsService from "../../../../services/Company/AssetsService";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";

const Assets = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [view, setView] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const assetsService = new AssetsService();

	return (
		<div className="assets">
			<div className="mb-3 assets-div d-flex justify-content-between p-3 align-items-center">
				<div></div>
				<div className="add-assets">
					<Button
						variant="primary"
						className="me-2 h-75"
						onClick={() => {
							setItem({});
							setAddModal(true);
						}}>
						<i className="la la-plus mx-1"></i>
						{Translate[lang]?.add} {Translate[lang]?.assets}
					</Button>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "300px" }}>
									<Loader />
								</div>
							)}
							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.serial_number}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.items}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.type}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.view}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.actions}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													key={index}
													item={item}
													setView={setView}
													setItem={setItem}
													setAddModal={setAddModal}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={assetsService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={""}
							/>
						</div>
					</Card>
				</Col>
			</Row>

			{addModal && (
				<AddAssetsModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => {
						setAddModal(false);
						setView(false);
					}}
					view={view}
				/>
			)}
		</div>
	);
};

export default Assets;
